import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const RefetchLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-refetch'
      text={t('ticketPage.refetchTicketLink')}
    />
  )
}

RefetchLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default RefetchLink
